<template>
    <b-card
        v-if="card.enabled"
        class="sell-card"
        header-class="text-center bg-white border-bottom-0 px-4"
        footer-class="bg-white p-4 border-top-0"
        body-class="pb-0"
    >
        <template
            v-slot:header
        >
            <sell-card-header :card="card" />
        </template>

        <template v-slot:default>
            <sell-card-content :card="card" />
        </template>

        <template v-slot:footer>
            <sell-card-footer :card="card" />
        </template>
    </b-card>
</template>

<script>
    import './SellCard.scss';
    import SellCardContent from "./SellCardContent/SellCardContent";
    import SellCardHeader from "./SellCardHeader/SellCardHeader";
    import SellCardFooter from "./SellCardFooter/SellCardFooter";
    export default {
        name: "SellCard",
        components: {SellCardFooter, SellCardHeader, SellCardContent},
        props: {
            card: {
                type: Object,
                required: true,
            }
        }
    };
</script>
